<script setup lang="ts">
import type { SelfAssessmentProps } from '@core/types'
import beGambleAwareSvg from '@/assets/authority/begambleaware-simple.svg?component'

const { state, next } = useCycleList([
    0,
    1
])

const props = defineProps<SelfAssessmentProps>()

useIntervalFn(() => {
    next()
}, 5_000)
</script>

<template>
    <UISelfAssessment v-bind="props">
        <template #middle>
            <template v-if="state === 0">
                <span>18+</span> |
                <NuxtLink :to="{ name: 'safer-gambling' }" target="_blank">
                    Play responsibly. Need help?
                </NuxtLink> | <NuxtLink
                    class="self-assessment__be-gamble-aware-logo"
                    href="https://www.begambleaware.org/"
                    target="_blank"
                    rel="noopener"
                >
                    <component :is="beGambleAwareSvg" />
                </NuxtLink>
            </template>

            <template v-else>
                <span>18+</span> | <NuxtLink href="https://www.gamcare.org.uk/get-support/talk-to-us-now/" target="_blank" rel="noopener">
                    National Gambling Helpline
                </NuxtLink>-<a href="tel:0808 8020 133" target="_blank">
                    (0808 8020 133)
                </a>
            </template>
        </template>

        <template #right>
            <ClientOnly>
                <UIClockCounter />
            </ClientOnly>
        </template>
    </UISelfAssessment>
</template>

<style lang="scss" scoped>
.self-assessment {
    &__be-gamble-aware-logo {
        align-items: center;
        color: inherit;
        display: inline-flex;
        justify-content: center;
        transition: transform 0.25s ease-in-out;
        width: 96px;

        :deep(svg) {
            height: auto;
            width: auto;
            max-width: 100%;
            max-height: 100%;
            vertical-align: middle;

            path,
            rect,
            circle {
                fill: currentColor;
            }
        }
    }
}

:deep(.self-assessment__middle) {
    gap: 0 4px;
}

:deep(.clock__icon) {
    color: #fff !important;
}
</style>
